import { useMutation } from "react-query";
import { apiClient } from "common/api-client/api-client";
import {
  showErrorToast,
  showSuccessToast,
  showWarningToast,
  useToastDispatch,
} from "common/context/toast/toast-context";
import { getLocalStorageItem } from "common/utils/storage/local-storage";
import { CURRENT_BUDGET } from "features/budget/budget.constants";

function getValue(value) {
  return value / 100;
}

export function getEmployeeData(source) {
  const employeesData = source.map(
    ({
      budgetScenarioEmployeeAllocationId,
      employeeRecordId,
      allocation,
      orgDetailId,
    }) => ({
      budgetScenarioEmployeeAllocationId,
      employeeRecordId,
      allocation: getValue(allocation),
      orgDetailId: Number(orgDetailId),
    }),
  );

  return {
    allocations: employeesData,
  };
}

export function getAllocationPayload(flexInstance) {
  const source = flexInstance.collectionView.sourceCollection;

  return getEmployeeData(source);
}

export function getAllocationWithoutPopup(data) {
  return getEmployeeData(data);
}

async function postAllocations({ allocations }) {
  const scenarioId = getLocalStorageItem(CURRENT_BUDGET);
  const result = await apiClient(
    `BudgetScenario/${scenarioId}/Workforce/Employee/Allocation`,
    {
      body: { employeeRecordsToAllocate: allocations },
    },
  );
  if (result instanceof Error) {
    throw result;
  }
  if (result.kind === "empty") {
    throw new Error("Response does not have a body");
  }

  return result.body;
}

function useSaveEmployeeAllocation(handleCloseDialog, orgId, setOrgId) {
  const toastDispatch = useToastDispatch();

  return useMutation(postAllocations, {
    onError: (error) => {
      showErrorToast(
        toastDispatch,
        "Error saving employee allocation",
        error.message,
      );
    },
    onSuccess: (response) => {
      setOrgId(-1);

      if (response?.validation === false) {
        showWarningToast(
          toastDispatch,
          "Validation failed for employee allocation",
          response.message,
        );
        setOrgId(orgId);
      } else {
        setOrgId(orgId);
        showSuccessToast(toastDispatch, "Employee allocated successfully");
        handleCloseDialog();
      }
    },
  });
}

export default useSaveEmployeeAllocation;
